import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CmsConfig, provideConfig, UrlModule } from '@spartacus/core'
import { CarouselModule, MediaModule } from '@spartacus/storefront'
import { CustomProductReferencesComponent } from './custom-product-references.component'

@NgModule({
  imports: [CommonModule, CarouselModule, MediaModule, RouterModule, UrlModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductReferencesComponent: {
          component: CustomProductReferencesComponent
        }
      }
    })
  ],
  declarations: [CustomProductReferencesComponent],
  exports: [CustomProductReferencesComponent]
})
export class CustomProductReferencesModule {}
